import ChartTabs from './ChartTabs';

export default ChartTabs;
